export const SELECTOR_WIDTH: number = 240;
